'use client';

import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

export default function BenefitsSection() {
  const { t } = useLanguage();

  return (
    <section
      id="beneficis"
      className="py-24 px-6 bg-[#07070b] relative overflow-hidden border-t border-white/5"
      aria-label="Què fa una web pel teu negoci"
    >
      {/* Background ambient lighting */}
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[350px] bg-gold/5 blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto space-y-16 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-gold/30 bg-gold/5 text-gold text-[11px] font-bold uppercase tracking-widest">
            {t.benefits.badge}
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white tracking-tight uppercase">
            {t.benefits.title}
          </h2>
          <p className="text-slate-300 text-sm sm:text-base leading-relaxed">
            {t.benefits.sub}
          </p>
        </div>

        {/* 6 Grid items */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {t.benefits.items.map((item, idx) => (
            <div
              key={idx}
              className="group p-8 rounded-2xl bg-gradient-to-b from-[#101018] to-[#0a0a0f] border border-white/10 hover:border-gold/40 hover:shadow-xl hover:shadow-gold/5 transition-all duration-300 space-y-4"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-gold/20 via-purple-brand/20 to-transparent border border-gold/30 flex items-center justify-center text-gold font-bold text-lg group-hover:scale-105 transition-transform">
                0{idx + 1}
              </div>
              <h3 className="text-xl font-bold text-white group-hover:text-gold transition-colors">
                {item.title}
              </h3>
              <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
